/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateIntegrationVersionRequest
 */
export interface CreateIntegrationVersionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateIntegrationVersionRequest
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateIntegrationVersionRequest
     */
    sourceCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateIntegrationVersionRequest
     */
    releaseNotes?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateIntegrationVersionRequest
     */
    isLatest?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CreateIntegrationVersionRequest
     */
    packageInfo?: { [key: string]: any; };
}

/**
 * Check if a given object implements the CreateIntegrationVersionRequest interface.
 */
export function instanceOfCreateIntegrationVersionRequest(value: object): value is CreateIntegrationVersionRequest {
    return true;
}

export function CreateIntegrationVersionRequestFromJSON(json: any): CreateIntegrationVersionRequest {
    return CreateIntegrationVersionRequestFromJSONTyped(json, false);
}

export function CreateIntegrationVersionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIntegrationVersionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'version': json['version'] == null ? undefined : json['version'],
        'sourceCode': json['sourceCode'] == null ? undefined : json['sourceCode'],
        'releaseNotes': json['releaseNotes'] == null ? undefined : json['releaseNotes'],
        'isLatest': json['isLatest'] == null ? undefined : json['isLatest'],
        'packageInfo': json['packageInfo'] == null ? undefined : json['packageInfo'],
    };
}

export function CreateIntegrationVersionRequestToJSON(json: any): CreateIntegrationVersionRequest {
    return CreateIntegrationVersionRequestToJSONTyped(json, false);
}

export function CreateIntegrationVersionRequestToJSONTyped(value?: CreateIntegrationVersionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'version': value['version'],
        'sourceCode': value['sourceCode'],
        'releaseNotes': value['releaseNotes'],
        'isLatest': value['isLatest'],
        'packageInfo': value['packageInfo'],
    };
}

